import React, { useState } from 'react';

import { check } from '@/assets/icons';
import { Label } from '@/components/shared/Inputs/Label';
import {
	SettingsList,
	SettingsListItems,
} from '@/components/shared/SettingCard';
import { SingleActionLayout } from '@/components/shared/SingleActionLayout/SingleActionLayout';
import { DefaultKeys } from '@/config/constants';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { SvgIcon } from '@material-ui/core';

import { IPropsSongModalDisplay } from '../SongModalPanel';
import styles from './DefaultKey.module.scss';

export const DefaultKey: React.FC<IPropsSongModalDisplay> = ({
	openedSong,
	updateTeamSong,
	popDisplayState,
}) => {
	const { defaultKey, name, recommendedKey } = openedSong;
	const [touched, setTouched] = useState(false);
	const [selectedKey, setSelectedKey] = useState<string | null | undefined>(
		defaultKey,
	);
	const fireSaveDefaultKeyEvent = useAnalyticsEvent(
		'View_Song_Save_Default_Key',
	);

	const keyItems: SettingsListItems = DefaultKeys.map((key) => ({
		type: 'setting' as const,
		title: key,
		subtitle: key === recommendedKey ? 'Recommended' : undefined,
		trailingComponent: key === selectedKey ? (
			<div className={styles['key-check--selected']}>
				<SvgIcon component={check} />
			</div>
		) : undefined,
		onClick: () => {
			setTouched(true);
			setSelectedKey(key);
		},
	}));

	return (
		<SingleActionLayout
			noPadding
			actionDisabled={!touched}
			actionLabel="Save Default Key"
			onActionClick={() => {
				updateTeamSong({ defaultKey: selectedKey });
				popDisplayState();
				fireSaveDefaultKeyEvent();
			}}
		>
			<div className={styles['root']}>
				<Label className={styles['label']}>
					Select for <span className={styles['song-name']}>{name}</span>
				</Label>
			</div>
			<div className={styles['list-wrapper']}>
				<SettingsList items={keyItems} />
			</div>
		</SingleActionLayout>
	);
};
